import * as sharedModals from "shared/modals";
import DialogService from "shared/modals/DialogService";
import ModalService from "shared/modals/ModalService";

import * as appModals from "src/modals";

ModalService.registerModals({ ...sharedModals, ...appModals });

export default ({ app }) => {
  // eslint-disable-next-line no-param-reassign
  app.config.globalProperties.$modals = ModalService;
  // eslint-disable-next-line no-param-reassign
  app.config.globalProperties.$dialog = DialogService;
};
